import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TokenService } from './services/auth/token.service';
import { PayLoginHttpInterceptor } from './utils/interceptors/pay-login-http.interceptor';
import { routes } from './app.routes';

function initializeApp(language: TranslateService): () => void {
  return () => {
    const queryParams = new URLSearchParams(document.location.search);
    TokenService.sessionId = queryParams.get('sessionId');
    TokenService.logoutReason = atob(queryParams.get('source') ?? '');
    TokenService.retryURl = queryParams.get('retryUrl');
    language.addLangs(['en', 'de', 'fr', 'nl']);
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(TranslateService));
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PayLoginHttpInterceptor,
      multi: true,
    },
    provideAnimations(),
    {
      provide: LOCALE_ID,
      useValue: 'nl-NL',
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: './assets/i18n/',
          suffix: '.json?ts=' + new Date().getTime(),
        }),
        fallbackLang: 'en',
      }),
    ),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
